// Ícone padrão (círculo)
const iconDefault = {
  // eslint-disable-next-line
  path          : google.maps.SymbolPath.CIRCLE,
  scale         : 10,
  strokeWeight  : 1,
  strokeColor   : "#000000",
  strokeOpacity : 1.0,
  fillOpacity   : 1.0
}

function getHeartbeatColor(flags={}) {
  if ( flags.hasProblems ) return "#ff0000"
  if ( !flags.engineOn ) return "#0000ff"
  if ( flags.hasSpeed ) return "#00ff00"
  return "#ffff00" // verde
}

export default class HeartbeatCircle {
  constructor(omap) {
    // eslint-disable-next-line
    this.marker = new google.maps.Marker({
      icon: iconDefault
    })

    this.omap = omap
    omap.addObject(this.marker)
  }

  // point pode ser um heartbeat (com .latitude)
  setPosition(point) {
    this.marker.setPosition(point)
    return this
  }

  // não usado (era para fazer track() neste objeto)
  setMap(map) {
    this.map = map
    // this.marker = setPosition(point)
    return this
  }

  setColor(flags) {
    let fillColor = getHeartbeatColor(flags),
        icon = Object.assign({fillColor}, iconDefault)
    this.marker.setOptions({icon})
    return this
  }

}
